import { option_question, option_level } from "../../../service/option";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";

export default function ModuleQuestionType2({ closePrePop, popPreOption }) {
  const renderItem = ({ text }) => (
    <>
      <div className="flex align-items-center">
        <i className="pi pi-send text-sm rotate-45 mr-2"></i>
        <span>{text}</span>
      </div>
    </>
  );

  return (
    <>
      <div className="px-3">
        <div className="text-lg font-bold text-blue-600">
          下列每一題目之後均有四種「符合程度」的選項，由左到右分別是完全符合、大部分符合、部分符合、以及完全不符合，請您依實際的經驗與感受，圈選出您認為最適合的選項。
        </div>

        <table className="w-full mt-2">
          <thead>
            <tr>
              <th></th>
              {option_level.type2.map((lvItem) => (
                <th key={lvItem.value} className="py-2">
                  {lvItem.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {option_question.type2.map((qItem, qIdx) => (
              <tr key={qItem.key}>
                <td>
                  {qIdx + 1}. {qItem.title}
                </td>
                {option_level.type2.map((lvItem) => (
                  <td
                    key={`${qItem.key}_${lvItem.value}`}
                    className="text-center py-2"
                  >
                    <Checkbox
                      name={qItem.key}
                      value={lvItem.value}
                      checked={popPreOption.data?.[qItem.key] === lvItem.value}
                      disabled={true}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        <div className="line-height-4 mt-3">
          <div className="flex align-items-start mt-2">
            <div>一、</div>
            <div>
              以4 點量表方式填答，分數愈高表示該部分之生涯召喚程度愈明顯。
            </div>
          </div>
          <div className="flex align-items-start mt-2">
            <div>二、</div>
            <div>
              生涯召喚為一種生涯方面的驅力與召喚引導力量，其為一多方面概念，包括興趣熱情、存在意義、利他助人以及超越奉獻，各構面定義如下：
            </div>
          </div>
          <div style={{ marginLeft: "1.9rem" }}>
            {renderItem({ text: "興趣熱情：工作或生涯展現興趣與熱情。" })}
            {renderItem({
              text: "存在意義：工作或生涯能實踐存在價值或展現個人意義。",
            })}
            {renderItem({
              text: "利他助人：工作或生涯能對他人、組織或社會產生助益或影響。",
            })}
            {renderItem({ text: "超越奉獻：工作或職涯能呼應超越個人之召喚。" })}
          </div>
          <div className="flex align-items-start mt-2">
            <div>三、</div>
            <div>
              本量表分為四大構面：興趣熱情、存在意義、利他助人、超越奉獻
            </div>
          </div>
          <div style={{ marginLeft: "1.9rem" }}>
            {renderItem({ text: "興趣熱情：第2、3、7、8、11題" })}
            {renderItem({
              text: "存在意義：第10、13、15、16、20題",
            })}
            {renderItem({
              text: "利他助人：第1、4、6、9、17、18題",
            })}
            {renderItem({ text: "超越奉獻：第5、12、14、19題" })}
          </div>
        </div>

        <div className="text-right mt-3">
          <Button
            className="p-button-secondary w-auto px-3"
            type="button"
            label="關閉"
            onClick={() =>
              closePrePop({
                type: "question",
              })
            }
          />
        </div>
      </div>
    </>
  );
}
